export default __webpack_public_path__ + "static/media/Group 1.12ca94ca.png";